import { Alert } from 'antd';

export const Forbidden = () => {
  return (
    <div className="forbidden">
      <Alert message="You don't have permission." type="error" />
    </div>
  );
};
